import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQueryWithReauth } from '../../api';
import { IProductDetails, IProductResponse, ISellerProductsQueryParams } from './interface';
import { ISellerDashboardBestSellerProductsResponse } from '../dashboardApi/interface';
import { generateQueryString } from '../../../utils/queryKey';

export const productApi = createApi({
  reducerPath: 'productApi',
  baseQuery: baseQueryWithReauth,
  tagTypes: ['SellerProduct'],
  endpoints: (builder) => ({
    createProduct: builder.mutation<IProductResponse, FormData>({
      query: (formData) => ({
        url: `/products/`,
        method: 'POST',
        body: formData
      }),
    }),

    getProductsByStore: builder.query<IProductDetails[], string>({
      query: (storeId) => ({
        url: `/products/store/${storeId}`,
        method: 'GET',
      }),
    }),

    getSellerProducts: builder.query<ISellerDashboardBestSellerProductsResponse, ISellerProductsQueryParams>({
      query: (params) => ({
        url: `/seller-management/products?${generateQueryString({ ...params })}`,
        method: 'GET',
      }),
      providesTags: ['SellerProduct'],
    }),
  }),
});

export const {
  useCreateProductMutation,
  useGetProductsByStoreQuery,
  useGetSellerProductsQuery,
} = productApi;